export const reduxKey = '@@firstTimeFlags';
export const localStorageKey = '@@firstTimeFlags';
export var FirstTimeFlag;
(function(FirstTimeFlag) {
    FirstTimeFlag["ProfileHeroAidNotClosed"] = "isProfileHeroAidNotClosed";
    FirstTimeFlag["WelcomePopupNotClosed"] = "isWelcomePopupNotClosed";
    FirstTimeFlag["IsJournalCoverNotUsed"] = "isJournalCoverNotUsed";
    FirstTimeFlag["IsChatGeneralTabNotUsed"] = "isChatGeneralTabNotUsed";
    FirstTimeFlag["IsNetworkbarGroupWatchNotUsed"] = "isNetworkbarGroupWatchNotUsed";
    FirstTimeFlag["IsDevpageAddToGroupNotShown"] = "isDevpageAddToGroupNotShown";
    FirstTimeFlag["IsNewNCHeaderNotAcknowledged"] = "isNewNcHeaderNotAcknowledged";
    FirstTimeFlag["IsNewNCPageNotAcknowledged"] = "isNewNcPageNotAcknowledged";
    FirstTimeFlag["IsBrowseSubscriptionsPromotionNotSeen"] = "isBrowseSubscriptionsPromotionNotSeen";
    FirstTimeFlag["IsMsLockedArtNotSeen"] = "isMsLockedArtNotSeen";
    FirstTimeFlag["IsMsSubscriptionNotPurchased"] = "isMsSubscriptionNotPurchased";
    FirstTimeFlag["IsDyw3RemoveNotSeen"] = "isDyw3RemoveNotSeen";
    FirstTimeFlag["IsDyw3WatchBannerNotSeen"] = "isDyw3WatchBannerNotSeen";
    FirstTimeFlag["IsDyw3SubscriptionsFilterNotSeen"] = "isDyw3SubscriptionsFilterNotSeen";
    FirstTimeFlag["IsMsFirstTierNotCreated"] = "isMsFirstTierNotCreated";
    FirstTimeFlag["IsAppInstallCalloutNotClosed"] = "isAppInstallCalloutNotClosed";
    FirstTimeFlag["IsAppInstallToastNotClosed"] = "isAppInstallToastNotClosed";
    FirstTimeFlag["IsCustomboxNotDiscovered"] = "isCustomboxNotDiscovered";
    FirstTimeFlag["IsDreamupPromptGuidelinesNotSeen"] = "isDreamupPromptGuidelinesNotSeen";
})(FirstTimeFlag || (FirstTimeFlag = {}));
